import { useCallback } from 'react';

import { Dataflow03Icon } from '@/components/icons/Dataflow03Icon';
import {
  MenuItem,
  MenuItemProps,
} from '@/components/poppers/MenuPopper/MenuItem';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

import { DocumentsTableRowData } from '../DocumentsTable.types';

interface ViewDocumentKnowledgeGraphV2ActionItemProps
  extends Partial<MenuItemProps> {
  row: DocumentsTableRowData;
  householdId: string;
  disabled?: boolean;
}

/**
 * @description Admin-only action item component for use by the table ActionButtonRenderer.
 * Opens the Knowledge Graph V2 Visualizer for the document in a new tab.
 */
export function ViewDocumentKnowledgeGraphV2ActionItem({
  row,
  householdId,
  disabled,
  ...menuItemProps
}: ViewDocumentKnowledgeGraphV2ActionItemProps) {
  const handleClick = useCallback(() => {
    const path = getCompletePathFromRouteKey(
      ROUTE_KEYS.DOCUMENT_KNOWLEDGE_GRAPH_V2,
      {
        householdId,
        documentId: row.id,
      }
    );
    window.open(path, '_blank');
  }, [householdId, row.id]);

  return (
    <MenuItem
      icon={<Dataflow03Icon size={18} />}
      label="View KG V2"
      onClick={handleClick}
      disabled={disabled}
      {...menuItemProps}
    />
  );
}
